import {cx} from "@emotion/css";

import {ReactComponent as SvgBell} from "~/assets/svg/bell.svg";
import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmBellIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgBell id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
